/**
 * KeyValuePair.ts
 */
export class KeyValuePair {
    constructor(key, value) {
        this.key = key;
        this.value = value;
    }
    getKey() {
        return this.key;
    }
    getValue() {
        return this.value;
    }
}
//# sourceMappingURL=KeyValuePair.js.map